<mat-form-field appearance="outline" class="station-multiselect-field full-width" subscriptSizing="dynamic">
  <mat-label>{{ label }}@if (required) { *}</mat-label>

  <mat-chip-grid #chipGrid aria-label="Selected stations">
    @for (station of selectedStations; track station.id) {
      <mat-chip-row (removed)="removeStation(station)">
        {{ stationLabel(station) }}
        <button matChipRemove type="button" [attr.aria-label]="'Remove ' + station.name">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      [placeholder]="selectedStations.length ? 'Search…' : placeholder"
      [formControl]="searchControl"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="stationAuto"
    />
  </mat-chip-grid>

  <mat-icon matSuffix>radio</mat-icon>

  <mat-autocomplete #stationAuto="matAutocomplete" (opened)="onPanelOpened()" (optionSelected)="onStationSelected($event)">
    @if (filteredStations.length === 0) {
      <mat-option disabled>No stations found</mat-option>
    } @else {
      @for (station of filteredStations; track station.id) {
        <mat-option [value]="station.id">
          <span class="option-line">
            <span class="option-name">{{ station.name }}</span>
            <span class="option-call-sign">{{ station.call_sign }}</span>
          </span>
        </mat-option>
      }
    }
  </mat-autocomplete>

  @if (hint) {
    <mat-hint>{{ hint }}</mat-hint>
  } @else {
    <mat-hint>Select from the list or type to search</mat-hint>
  }
</mat-form-field>
